<template>
  <div class>
    <cContentEdit
      :canEdit="false"
      :editMode="editMode"
      :title="$t('cHotelAmenities.title')"
    >
      <div>
        <CRow>
          <CCol>
            <cTextInputComponent
              :label="$t('cHotelAmenities.searchPl')"
              @input="onAmenitiesSearch"
              v-model="searchVal"
              :placeholder="$t('cHotelAmenities.searchPl')"
            ></cTextInputComponent>
          </CCol>
  
          <CCol
            v-if="allAmenitiesRes && allAmenitiesRes.length"
           
          >
            <label class="py-2">
              <input
                type="checkbox"
                v-model="isSelectAll"
                @change="selectAllAmenities(isSelectAll)"
              />

              {{ $t("cHotelAmenities.selectAll") }}
            </label>
          </CCol>
        </CRow>

        <div class="row" v-if="lsAllAmenities && lsAllAmenities.length">
        
            <div class="col-md-4" 
              v-for="(amenitiy, index) in lsAllAmenities"
              :key="index + 'amnities'"
            >
              <label class="p-3">
                <input
                  class="mr-2"
                  @input="selectAmenitiy(amenitiy)"
                  type="checkbox"
                  :checked="
                    lsSelectedAmenities.some(
                      (val) => val.amenitiesId == amenitiy.amenitiesId
                    )
                  "
                />
                {{ amenitiy.amenitiesName }}
              </label>
            </div>
                <CLink class="py-2 px-4"
              v-if="allAmenitiesRes && allAmenitiesRes.length > 10 && !searchVal"
              @click="onShowMore"
            >
              {{
                !showMore
                  ? $t("cHotelAmenities.showMore")
                  : $t("cHotelAmenities.showLess")
              }}
            </CLink>
          
        </div>
         <div class="col-md-4"   v-else>
            <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
          </div>
      </div>
    </cContentEdit>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { COMPONENT_NAME, ORDER, PATHNAME } from "../../../../util/constants";
import router, { navigate } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  removeDuplicates,
  cloneDeep,
} from "../../../../util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import apiGetAllHotelAmenities from "../../../../services/apiGetAllHotelAmenities";
import apiUpdateHotelAmenities from "../../../../services/apiUpdateHotelAmenities";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
export default {
  name: COMPONENT_NAME.C_ROOM_AMENITIES,

  components: {
    cContentEdit,
    cTextInputComponent,
  },

  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },

    selAmenities: {
      type: Array,
      default: null,
    },
  },

  data: () => {
    return {
      editMode: false,
      alertValue: null,
      canEdit: true,
      allAmenitiesRes: [],
     searchVal:null,
      isSelectAll: false,

      showMore: false,

      lsAllAmenities: [],
      lsSelectedAmenities: [],
    };
  },

  computed: {
    ...mapGetters("sHotelInfo", {
      hotelObj: "GET_HOTEL_OBJ",
    }),
  },

  methods: {
    showAlert(val) {
      this.alertValue = val;
    },

    selectAllAmenities(val) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectAllAmenities");

        if (val) {
          this.lsSelectedAmenities = cloneDeep(this.allAmenitiesRes);
          this.lsAllAmenities = cloneDeep(this.allAmenitiesRes);
        } else {
          this.lsSelectedAmenities = [];
        }
        this.$emit("onSelect", this.lsSelectedAmenities);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in selectAllAmenities",
          err.toString(),
          "selectAllAmenities",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onShowMore() {
      try {
        if (BaseConfiguration.isDebug) console.log("onShowMore");
        this.showMore = !this.showMore;

        if (this.showMore) {
          this.lsAllAmenities = cloneDeep(this.allAmenitiesRes);
        } else {
          this.lsAllAmenities = this.allAmenitiesRes.slice(0, 10);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in onShowMore",
          err.toString(),
          "onShowMore",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    selectAmenitiy(pAmenitiy) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectAmenitiy");

        if (pAmenitiy) {
          if (
            this.lsSelectedAmenities.find(
              (amenity) => amenity.amenitiesId == pAmenitiy.amenitiesId
            )
          ) {
            this.lsSelectedAmenities = this.lsSelectedAmenities.filter(
              (amenity) => amenity.amenitiesId != pAmenitiy.amenitiesId
            );
          } else {
            this.lsSelectedAmenities.push(pAmenitiy);
          }
          this.$emit("onSelect", this.lsSelectedAmenities);
        } else {
          throw "invalid amenitiy";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in selectAmenitiy",
          err.toString(),
          "selectAmenitiy",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onAmenitiesSearch(pPartialAmenityName) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAmenitiesSearch");

        if (this.allAmenitiesRes && this.allAmenitiesRes.length) {
          this.lsAllAmenities = this.allAmenitiesRes.filter((amenity) =>
            amenity.amenitiesName
              .toString().trim()
              .toLowerCase()
              .includes(pPartialAmenityName.toString().trim().toLowerCase())
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in onAmenitiesSearch",
          err.toString(),
          "onAmenitiesSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getAllHotelAmenities() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAllHotelAmenities");

        if (this.hotelObj) {
          let hotelAmenitiesReq = apiGetAllHotelAmenities.buildRequest(
            this.hotelObj.hotelid
          );

          if (hotelAmenitiesReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let hotelAmenitiesRes = await apiGetAllHotelAmenities.getResponse(
              hotelAmenitiesReq
            );

            if (VALIDATE_SUCCESS_RES(hotelAmenitiesRes)) {
              this.showAlert(null);
              retValue = hotelAmenitiesRes.data.data;
              
            } else {
              let error = getErrorMessage(hotelAmenitiesRes);
              this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in getAllHotelAmenities",
          err.toString(),
          "getAllHotelAmenities",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getSelAmenities(pAmenitiy) {
      let retValue = false;
      try {
        if (BaseConfiguration.isDebug) console.log("getSelAmenities");

        retValue = this.lsSelectedAmenities.some(
          (amenities) => amenities.amenitiesId == pAmenitiy.amenitiesId
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_AMENITIES,
          "error in getSelAmenities",
          err.toString(),
          "getSelAmenities",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      this.editMode = this.showEdit;
      let hotelAmenitiesRes = await this.getAllHotelAmenities();
      if (hotelAmenitiesRes && hotelAmenitiesRes.amenities) {
        this.allAmenitiesRes = hotelAmenitiesRes.amenities;
      }

      if (this.selAmenities) {
        this.lsSelectedAmenities = this.allAmenitiesRes.filter((amenity) =>
          this.selAmenities.includes(amenity.amenitiesId)
        );
      
      this.allAmenitiesRes = this.allAmenitiesRes.filter(
        (amenities) => !this.selAmenities.includes(amenities.amenitiesId)
      );

      this.allAmenitiesRes = [
        ...this.lsSelectedAmenities,
        ...this.allAmenitiesRes,
      ];
      }
      this.lsAllAmenities = this.allAmenitiesRes.slice(0, 10);
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_ROOM_AMENITIES,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style></style>
